import { RootState } from "~/store/rootReducer"

export const selectFrameSize = (state: RootState) => state.currentFrameSizeReducer
